import { isMobile } from '@pascal/pascal-core';
import { gsap, TimelineLite } from 'gsap/gsap-core';

import { delay } from '../helpers/delay';
import { gameDrawer } from '../gameDrawer';
import { GameApplicationType } from '../enums/game-scene';
import { mobileConfigs, webConfigs } from '../core/configs/applicationConfig';

gsap.ticker.lagSmoothing(0, 700);

class DiceAnimations {
  constructor(drawer) {
    this.drawer = drawer;
    this.dicesContainer = null;
    this.mode = isMobile() ? GameApplicationType.mobile : GameApplicationType.web;
    this.configs = this.mode === GameApplicationType.web ? webConfigs : mobileConfigs;
    this.currentDices = null;
  }

  setDices(diceResult) {
    this.dicesSum = diceResult.reduce((acc, value) => {
      return acc + value;
    }, 0);

    this.destroy();
    return new Promise((res) => {
      diceResult.forEach((dice, index) => {
        this.dicesContainer = gameDrawer.setDices(dice, index);
      });
      this.currentDices = this.dicesContainer.children;
      res(this.currentDices);
    });
  }

  setDicesAnimation(time) {
    const nextDelay = time + 2.1 >= 0 ? 0 : time + 2.1; // prev anim duration + current anim duration
    return new Promise((res) => {
      delay(() => {
        res(nextDelay);
      }, 3000);

      this.currentDices?.forEach((texture, index) => {
        gsap.to(texture, 0.1, {
          delay: time + 2 + 0.1 * index,
          pixi: {
            alpha: 1,
          },
          onComplete: () => {
            if (this.currentDices?.length === index + 1) {
              res(nextDelay);
            }
          },
        });
      });
    });
  }

  rearrangeDicesAnimation(time) {
    if (time > -1) {
      this.setWinNumber(this.dicesSum);
    }
    const nextDelay = time + 1.5 >= 0 ? 0 : time + 1.5; // prev anim duration + current anim duration
    return new Promise((res) => {
      delay(() => {
        res(nextDelay);
      }, 2500);
      this.currentDices?.forEach((texture, index) => {
        gsap.to(texture, 1, {
          ease: 'expo',
          ...this.configs.dicesSecondPositions[index],
          delay: time + 0.5,
          pixi: {
            scale: texture.scale.x - 0.1,
          },
          onComplete: () => {
            if (this.currentDices.length === index + 1) {
              res(nextDelay);
            }
          },
        });
      });
    });
  }

  hideDices(time) {
    const nextDelay = time + 0.5 >= 0 ? 0 : time + 0.5; // prev anim duration + current anim duration
    let isStart = false;
    return new Promise((res) => {
      const a = delay(() => {
        res(nextDelay);
        isStart = true;
      }, 600);
      this.currentDices?.forEach((texture, index) => {
        gsap.to(texture, 0.5, {
          ...this.configs.chestInteriorPosition,
          delay: time,
          rotation: 8,
          pixi: {
            scale: 0.1,
          },
          onComplete: () => {
            if (this.currentDices.length === index + 1 && !isStart) {
              this.destroy();
              a.cancel();
              res(nextDelay);
            }
          },
        });
      });
    });
  }

  setWinNumber(number) {
    const numberTexture = gameDrawer.setWinNumberContainer(number);
    const timeLine = new TimelineLite();
    timeLine
      .to(numberTexture, {
        delay: 0.5,
        duration: 0.4,
        ...this.configs.winNumberAnimationPosition,
        pixi: {
          scale: 1,
        },
      })
      .to(numberTexture, {
        delay: 0.7,
        duration: 0.3,
        pixi: {
          scale: 0,
          alpha: 0,
        },
      });
  }

  destroy() {
    this.dicesContainer?.removeChildren();
  }
}

export const diceAnimations = new DiceAnimations();
